import { CalendarDayEvent } from "@/pages/human-resources/time-management/business/calendar/CalendarDayEvent.ts";
import { CalendarDay } from "@/pages/human-resources/time-management/business/calendar/CalendarDay.ts";
import type { CalendarDayEventOut } from "@/pages/human-resources/time-management/endpoints/calendar/inout/CalendarDayEventOut.ts";
import { legacyParseFrenchDate } from "@/shared/utils/LegacyDates.ts";

export interface CalendarDayOut {
  date: string;
  siteFerme: boolean;
  couleur?: string | null;
  jourFerie?: string | null;
  evenements?: CalendarDayEventOut[] | null;
}

export function mapToCalendarDay(calendarDayOut: CalendarDayOut): CalendarDay {
  const events = (calendarDayOut.evenements ?? []).map(
    (e) => new CalendarDayEvent(e.nom, e.commentaire),
  );
  return new CalendarDay(
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    legacyParseFrenchDate(calendarDayOut.date),
    calendarDayOut.siteFerme,
    calendarDayOut.couleur ?? undefined,
    calendarDayOut.jourFerie ?? undefined,
    events,
  );
}
